import React from 'react';
import PrimaryButton from '../../PrimaryButton';
import SecondaryButton from '../../SecondaryButton';
import { Link } from 'react-router-dom';

const KartenverwaltungHeader = () => {
  return (
    <div className="bg-white px-6 py-6 sm:py-6 lg:px-8">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">
          Deine sVisit-Karten
        </h2>
        <p className="mt-2 text-lg leading-8 text-gray-600">
          Hier siehst du alle physischen sVisit-Karten, die mit deinem Profil
          verknüpft sind.
        </p>
        {/* <Link to="#">
          <PrimaryButton content="Anleitung" />
        </Link> */}
        <Link to="/produkte">
          <SecondaryButton content="Neue Karte kaufen &rarr;" />
        </Link>
      </div>
    </div>
  );
};

export default KartenverwaltungHeader;
